<template>
  <div id="app">
    <div class="body_bg">
      <div class="container whitebg pd15">
        <el-row :gutter="25">
         <el-col :xs="24" :sm="24" :md="19" :lg="19" :xl="19" class="main-content">
            <div class="grid-content bg-purple-light">
              <div class="side_con">
                <div class="title_all" style="margin-bottom: 0">
                  <div class="title_left">Preprint</div>
                  <div class="title_more2"><a href="/EN">Home</a>>Preprint</div>
                  <div class="clearfix"></div>
                </div>
                <div class="side_container">
                  <div class="dqml fifth">
                    <IssueArticleListControl :List="newList" :isycb="isycb" :Periods="Periods" :id="2" :type="1">
                    </IssueArticleListControl>
                  </div>
                  <commonpage :count="count" @pageSize="pageSize" @pageindex="pageindex" :index="paramas"></commonpage>
                </div>
              </div>
            </div>
          </el-col>
          <DocumentsNewsBlockControl />
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import commonpage from '../components/CommonPage'
import IssueArticleListControl from '../components/IssueArticleListControl/IssueArticleListControl'
export default {
  data() {
    return {
      newList: [],
      count: 0,
      isycb: true,
      Periods: {},
      paramas: {
        PageSize: 10,
        PageIndex: 0,
        IssueId: 0,
      },
      paramsa: {
        PageSize: 10,
        PageIndex: 0,
        Type: 'Sort',
        Key: 'Preprint',
        src: '',
      },
    }
  },
  components: {
    IssueArticleListControl,
    commonpage,
  },
  mounted() {
    this.GetIssue()
    this._getList()
  },
  methods: {
    _getList(pageSize, PageIndex) {
      if (sessionStorage.getItem('SetItem')) {
        let SetItem = JSON.parse(sessionStorage.getItem('SetItem'))
        SetItem.map((item) => {
          if (item.SetItemID == 6018) {
            if (item.Item_Value == '是') {
              this._getLista(pageSize, PageIndex)
            } else {
              this._getListb(pageSize, PageIndex)
            }
          }
        })
      } else {
        let params = [
          1000, 1001, 4530, 6018, 6019, 230, 6055, 5000, 5010, 99, 96, 11, 2960,
        ]
        this.$store
          .dispatch('_getSet', params)
          .then((res) => {
            this.SetItem = res.data.Data
            sessionStorage.setItem('SetItem', JSON.stringify(res.data.Data))
            this.SetItem.map((item) => {
              if (item.SetItemID == 6018) {
                if (item.Item_Value == '是') {
                  this._getLista(pageSize, PageIndex)
                } else {
                  this._getListb(pageSize, PageIndex)
                }
              }
            })
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    _getLista(pageSize, PageIndex) {
      var time = new Date().getTime()
      this.params = {
        PageSize: pageSize,
        PageIndex: PageIndex,
        src: time,
      }
      this.$store
        .dispatch('_getLista', this.params)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.newList = res.data.Data
            this.count = res.data.ItemCount
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    _getListb(pageSize, PageIndex) {
      var time = new Date().getTime()
      this.paramsa = {
        PageSize: pageSize,
        PageIndex: PageIndex,
        Type: 'Sort',
        Key: 'Preprint',
        src: time,
      }
      this.$store
        .dispatch('_getListb', this.paramsa)
        .then((res) => {
          if (res.data.IsSuccess) {
            this.newList = res.data.Data
            this.count = res.data.ItemCount
          }
        })
        .catch((err) => {
          console.log(err, 'err')
        })
    },
    pageSize(val) {
      this._getList(val, this.paramsa.PageIndex)
    },
    pageindex(val) {
      this._getList(this.paramas.PageSize, val)
    },

    OpenGUIDFile(FileGUID) {
      this.$store
        .dispatch('_OpenGUIDFile', {
          FileGUID: FileGUID,
        })
        .then((res) => {
          if (res.data.IsSuccess) {
            this.$DownloadBase64File(res.data.Guid, 1)
          } else {
            this.$error(res.data.Message)
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    GetIssue() {
      this.$store
        .dispatch('_getYear', { Id: -1 })
        .then((res) => {
          this.newListTitle = res.data.Data.YearIssue_NoTtitle
          let data = {
            newYears: res.data.Data.Publish_Date,
            Volume: res.data.Data.Volume,
            CoverGUID: res.data.Data.CoverGUID,
            CoverSuffix: res.data.Data.CoverSuffix,
            YearIssue_NoTtitle: res.data.Data.YearIssue_NoTtitle,
          }
          sessionStorage.setItem('newYears', JSON.stringify(data))
          this.Periods = res.data.Data
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
}
</script>

<style scoped>
.dqml {
  margin-top: 0px !important;
}

.mc_menu {
  border: none !important;
}
</style>
